import {buildURL} from '@/utils/urlBuilder';

// Get settings namespace from centralized URL patterns
const getSettingsNamespace = () => {
    try {
        return buildURL('settingsNamespace');
    } catch (error) {
        return window.URLS?.settingsNamespace || '/app/settings';
    }
};

const settingsNamespace = getSettingsNamespace();

// Relative routes for settings namespace
const userPermissionsViewRelative = '/permissions';
const userPreferencesViewRelative = '/preferences';
const additionalAppsViewRelative = '/additional-apps';
const switchRoleSettingsViewRelative = '/switch-role';

// Absolute routes using centralized URL patterns with buildURL
const getUserPermissionsViewRoute = () => {
    try {
        return buildURL('userPermissionsView');
    } catch (error) {
        return window.URLS?.userPermissionsView || `${settingsNamespace}${userPermissionsViewRelative}`;
    }
};

const getUserPreferencesViewRoute = () => {
    try {
        return buildURL('userPreferencesView');
    } catch (error) {
        return window.URLS?.userPreferencesView || `${settingsNamespace}${userPreferencesViewRelative}`;
    }
};

const getAdditionalAppsViewRoute = () => {
    try {
        return buildURL('additionalAppsView');
    } catch (error) {
        return window.URLS?.additionalAppsView || `${settingsNamespace}${additionalAppsViewRelative}`;
    }
};

const getSwitchRoleSettingsViewRoute = () => {
    try {
        return buildURL('switchRolesView');
    } catch (error) {
        return window.URLS?.switchRolesView || `${settingsNamespace}${switchRoleSettingsViewRelative}`;
    }
};

// Computed values (will be evaluated when accessed)
const userPermissionsViewRoute = getUserPermissionsViewRoute();
const userPreferencesViewRoute = getUserPreferencesViewRoute();
const additionalAppsViewRoute = getAdditionalAppsViewRoute();
const switchRoleSettingsViewRoute = getSwitchRoleSettingsViewRoute();

export const settingsNamespaces = {
    settingsNamespace,
};

export const settingsRelativeRoutes = {
    userPermissionsViewRelative,
    userPreferencesViewRelative,
    additionalAppsViewRelative,
    switchRoleSettingsViewRelative,
};

export const settingsAbsoluteRoutes = {
    userPermissionsViewRoute,
    userPreferencesViewRoute,
    additionalAppsViewRoute,
    switchRoleSettingsViewRoute,
};
